import React, { useState } from "react";
import { Bell } from "lucide-react";

const NotificationBell = ({ notifications = [] }) => {
  const [open, setOpen] = useState(false);

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="relative">
      {/* Bell Button */}
      <button
        onClick={() => setOpen(!open)}
        className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 relative"
      >
        <Bell size={20} />

        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] px-1.5 py-0.5 rounded-full">
            {unreadCount}
          </span>
        )}
      </button>

      {/* Notification Dropdown */}
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white shadow-lg rounded-lg border z-50">
          <div className="px-4 py-2 border-b font-semibold text-sm">
            Notifications
          </div>

          <ul className="max-h-80 overflow-y-auto">
            {notifications.length === 0 && (
              <li className="px-4 py-3 text-sm text-gray-500">
                No notifications
              </li>
            )}

            {notifications.map((n) => (
              <li
                key={n.id}
                className={`px-4 py-3 text-sm border-b hover:bg-gray-50 ${
                  !n.read ? "bg-blue-50" : ""
                }`}
              >
                <p className="font-medium">{n.title}</p>
                <p className="text-gray-500 text-xs">{n.message}</p>
                <p className="text-gray-400 text-[10px] mt-1">
                  {n.time}
                </p>
              </li>
            ))}
          </ul>

          <div className="p-2 text-center border-t">
            <a
              href="/notifications"
              className="text-blue-600 text-sm hover:underline"
            >
              View all
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;